import { client } from './generated/client.gen';

client.setConfig({
    baseUrl: '/api/v1',
    credentials: 'include',
});

export * from './generated';
